<template>
  <!-- Wrapper dengan background penuh -->
  <div class="relative bg-[#ffffff] min-h-screen w-full overflow-hidden">
    <!-- Efek Blur Glow di Bagian Bawah -->

    <!-- Parallax Background Elements -->
    <div class="absolute inset-0 z-0 pointer-events-none">
      <!-- Elemen Background Blur Mengambang -->
      <div 
        ref="parallaxBg1" 
        class="absolute -top-10 -right-10 w-80 h-80 bg-blue-300 rounded-full opacity-20 blur-3xl"
        :style="{ transform: `translate3d(${parallaxPos.x * 0.05}px, ${parallaxPos.y * 0.05}px, 0)` }"
      />
      <div 
        ref="parallaxBg2" 
        class="absolute bottom-20 -left-20 w-96 h-96 bg-indigo-200 rounded-full opacity-20 blur-3xl"
        :style="{ transform: `translate3d(${parallaxPos.x * -0.03}px, ${parallaxPos.y * -0.03}px, 0)` }"
      />
      <div 
        ref="parallaxBg3" 
        class="absolute top-40 left-1/4 w-64 h-64 bg-cyan-200 rounded-full opacity-20 blur-3xl"
        :style="{ transform: `translate3d(${parallaxPos.x * 0.07}px, ${parallaxPos.y * 0.07}px, 0)` }"
      />

      <!-- Elemen Dekoratif -->
      <div 
        class="absolute top-10 left-1/4 w-16 h-16 bg-purple-200 rounded-md rotate-12 opacity-70"
        :style="{ transform: `translate3d(${parallaxPos.x * 0.02}px, ${parallaxPos.y * 0.02}px, 0)` }"
      />
      
      <div 
        class="absolute bottom-10 right-1/4 w-20 h-20 bg-blue-200 rounded-full opacity-70"
        :style="{ transform: `translate3d(${parallaxPos.x * -0.03}px, ${parallaxPos.y * -0.04}px, 0)` }"
      />

      <div 
        class="absolute top-1/3 right-10 w-12 h-12 bg-emerald-200 rounded-full opacity-80"
        :style="{ transform: `translate3d(${parallaxPos.x * 0.06}px, ${parallaxPos.y * 0.08}px, 0)` }"
      />

      <div 
        class="absolute bottom-1/3 left-10 w-8 h-8 bg-indigo-200 rounded-md rotate-45 opacity-80"
        :style="{ transform: `translate3d(${parallaxPos.x * -0.05}px, ${parallaxPos.y * -0.07}px, 0)` }"
      />
    </div>

    <!-- Navbar -->
    <NavbarMain />

    <!-- Konten Dinamis (Router View) -->
    <main class="relative z-10">
      <router-view />
    </main>

    <!-- Footer -->
    <FooterMain />
  </div>
</template>

<script>
import NavbarMain from "./components/NavbarMain.vue";
import FooterMain from "./components/FooterMain.vue";

export default {
  components: {
    NavbarMain,
    FooterMain,
  },
  data() {
    return {
      parallaxPos: { x: 0, y: 0 }
    };
  },
  mounted() {
    window.addEventListener("mousemove", this.handleParallax);
  },
  beforeUnmount() { // Vue 3 menggunakan beforeUnmount, bukan beforeDestroy
    window.removeEventListener("mousemove", this.handleParallax);
  },
  methods: {
    handleParallax(event) {
      this.parallaxPos.x = (event.clientX - window.innerWidth / 2) / 10;
      this.parallaxPos.y = (event.clientY - window.innerHeight / 2) / 10;
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

body {
  font-family: 'Inter', sans-serif;
  overflow-x: hidden;
}
</style>
